/**
 * Format price in INR style — no decimals when whole number.
 * ₹599 instead of ₹599.00, but ₹599.50 stays as-is.
 */
export const formatINR = (amount: number): string => {
  return Number.isInteger(amount) ? `₹${amount}` : `₹${amount.toFixed(2)}`;
};
